import Home from './Home';
import Layout from '../../components/Layout';

async function action(context) {
  const params = new URLSearchParams(context.query);
  const rawDbn = params.get('dbn');
  if (context.isInitialRender && rawDbn) {
    const pathname = context.pathname.replace(/\/$/, '');
    params.delete('dbn');
    const search = params.toString();
    return {
      redirect: `${pathname}/${rawDbn.toUpperCase()}/${search ? `?${search}` : ''}`,
    };
  }

  return {
    component: (
      <Layout>
        <Home pathname={context.pathname} />
      </Layout>
    ),
  };
}

export default action;
